import styled from 'styled-components';

export const ProgramsContainer = styled.div``;

export const Hero = styled.section`
  background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
    url('/images/programs-hero.jpg') center/cover no-repeat;
  height: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: white;
  padding: 0 20px;

  h1 {
    font-size: 3rem;
    margin-bottom: 1rem;
  }

  p {
    font-size: 1.2rem;
    max-width: 600px;
  }
`;

export const ProgramSection = styled.section`
  padding: 80px 0;

  .container {
    display: grid;
    grid-template-columns: 1fr;
    gap: 3rem;
  }
`;

export const ProgramCard = styled.div`
  background: white;
  padding: 3rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  
  .icon {
    font-size: 3rem;
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: 1.5rem;
  }

  h2 {
    color: ${({ theme }) => theme.colors.primary};
    margin-bottom: 1rem;
    font-size: 1.8rem;
  }

  p {
    color: ${({ theme }) => theme.colors.text};
    line-height: 1.8;
    margin-bottom: 2rem;
  }

  .activities {
    h3 {
      color: ${({ theme }) => theme.colors.text};
      margin-bottom: 1rem;
      font-size: 1.2rem;
    }

    ul {
      list-style: none;
      
      li {
        color: ${({ theme }) => theme.colors.lightText};
        margin-bottom: 0.5rem;
        padding-left: 1.5rem;
        position: relative;

        &:before {
          content: "•";
          color: ${({ theme }) => theme.colors.primary};
          position: absolute;
          left: 0;
        }
      }
    }
  }
`;